import { t } from "../../shared/trendReportShared";

// Sending lives in its own card. In the old layout these two buttons sat in the
// same panel as the add-recipient form and the list, so the irreversible action
// was one stray click away from routine list editing.
export default function SendPanel({
  language,
  busy,
  error,
  notice,
  onSendTest,
  onSendNow,
}) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 className="text-xs font-bold uppercase tracking-wide text-gray-400 mb-3">
        {t("newsletterSendNow", language)}
      </h3>
      <div className="flex flex-col sm:flex-row gap-2">
        <button
          type="button"
          onClick={onSendTest}
          disabled={Boolean(busy)}
          className="flex-1 py-3 px-4 rounded-xl text-sm font-medium border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700/40 disabled:opacity-50"
        >
          {busy === "test"
            ? t("newsletterSending", language)
            : t("newsletterSendTest", language)}
        </button>
        <button
          type="button"
          onClick={onSendNow}
          disabled={Boolean(busy)}
          className="flex-1 py-3 px-4 rounded-xl text-sm font-medium bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50 transition-colors"
        >
          {busy === "send"
            ? t("newsletterSending", language)
            : t("newsletterSendNow", language)}
        </button>
      </div>
      {error && (
        <p className="mt-3 text-xs text-red-500 text-center">{error}</p>
      )}
      {notice && (
        <p className="mt-3 text-xs text-emerald-600 dark:text-emerald-400 text-center">
          {notice}
        </p>
      )}
    </div>
  );
}
